// extracted by css-extract-rspack-plugin
module.exports =  {"titleRow":"JoinWorkspaceAsAdminDialog-m__titleRow___KcdQM"};